exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".home-app .featured-courses-section .section-bottom {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n", ""]);
